/**
 * Devuelve true si el JWT ya venció (o es ilegible), comparando el claim `exp` con la hora actual.
 * @param {string} token
 * @returns {boolean}
 */
export function isTokenExpired(token) {
  if (!token) return true;
  const parts = token.split('.');
  if (parts.length !== 3) return true;
  try {
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload.exp) return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}
